import React, { useState, useEffect, useCallback } from 'react';
import { signOut } from 'firebase/auth';
import { collection, getDocs, query, orderBy, updateDoc, doc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { useNavigate } from 'react-router-dom';
import CancellationTab from '../components/CancellationTab';
import CommunityTab from '../components/CommunityTab';
import SupportTab from '../components/SupportTab';

const TABS = [
  { id: 'cancellation', label: 'Cancellation Feedback', icon: '📋' },
  { id: 'community', label: 'Community', icon: '🏘️' },
  { id: 'support', label: 'Support Emails', icon: '✉️' },
];

export default function AdminDashboard() {
  const [tab, setTab] = useState('cancellation');
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut(auth);
    navigate('/admin/login', { replace: true });
  }

  return (
    <div style={s.root}>
      <aside style={s.sidebar}>
        <div style={s.sidebarTop}>
          <div style={s.logoRow}>
            <svg width="28" height="28" viewBox="0 0 40 40" fill="none">
              <circle cx="20" cy="20" r="20" fill="rgba(255,255,255,0.15)" />
              <path d="M20 10c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 16a6 6 0 110-12 6 6 0 010 12z" fill="white" opacity="0.9"/>
              <circle cx="20" cy="20" r="3" fill="white"/>
            </svg>
            <span style={s.sidebarBrand}>Cura Admin</span>
          </div>
          <nav style={s.nav}>
            {TABS.map(t => (
              <button
                key={t.id}
                style={{ ...s.navBtn, ...(tab === t.id ? s.navBtnActive : {}) }}
                onClick={() => setTab(t.id)}
              >
                <span style={s.navIcon}>{t.icon}</span>
                {t.label}
              </button>
            ))}
          </nav>
        </div>
        <button style={s.signOutBtn} onClick={handleSignOut}>Sign Out</button>
      </aside>

      <main style={s.main}>
        {tab === 'cancellation' && <CancellationTab />}
        {tab === 'community' && <CommunityTab />}
        {tab === 'support' && <SupportTab />}
      </main>
    </div>
  );
}

const s = {
  root: { display: 'flex', minHeight: '100vh' },
  sidebar: {
    width: 240, flexShrink: 0,
    background: 'linear-gradient(180deg, var(--green-900) 0%, var(--green-800) 100%)',
    display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
    padding: '28px 16px',
    position: 'sticky', top: 0, height: '100vh',
  },
  sidebarTop: { display: 'flex', flexDirection: 'column', gap: 32 },
  logoRow: { display: 'flex', alignItems: 'center', gap: 10, paddingLeft: 8 },
  sidebarBrand: { color: 'white', fontSize: 17, fontWeight: 800, letterSpacing: '-0.2px' },
  nav: { display: 'flex', flexDirection: 'column', gap: 4 },
  navBtn: {
    display: 'flex', alignItems: 'center', gap: 10, padding: '11px 12px',
    background: 'transparent', color: 'rgba(255,255,255,0.65)',
    borderRadius: 'var(--radius-sm)', fontSize: 14, fontWeight: 600,
    textAlign: 'left', transition: 'all 0.15s',
  },
  navBtnActive: { background: 'rgba(255,255,255,0.15)', color: 'white' },
  navIcon: { fontSize: 16, width: 20, textAlign: 'center' },
  signOutBtn: {
    padding: '10px 12px', background: 'rgba(255,255,255,0.08)',
    color: 'rgba(255,255,255,0.55)', borderRadius: 'var(--radius-sm)',
    fontSize: 13, fontWeight: 600,
  },
  main: { flex: 1, padding: '32px', overflowY: 'auto', background: 'transparent' },
};
